import { SET_HEAD_TITLE, RECEIVE_USER, RESET_USER } from './action-types'
import { reqLogin } from '../api/index'
import {CLIENT_ID,CLIENT_SECRET} from '../config/config'
import storageUtils from '../utils/storageUtils'
import { message } from 'antd'
import { tableFormUtils } from '../utils/tableFormUtils'

/**
 * 设置头部标题的同步action
 */
export const setHeadTitle = (headTitle) => ({
  type: SET_HEAD_TITLE,
  data: headTitle,
})

/**
 * 登录同步action
 * @param {*} user
 * @returns
 */
export const receiveUser = (user) => ({ type: RECEIVE_USER, user })

/**
 * 登录异步action
 * @param {*} username
 * @param {*} password
 * @returns
 */
export const login = (username, password) => {
  return async (dispatch) => {
    const userData = {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
      grant_type: 'password',
      username,
      password,
    }
    const result = await reqLogin(tableFormUtils(userData))
    console.log(result);
    if (result.uid) {
      const user = result
      storageUtils.savaUser(user)
      dispatch(receiveUser(user))
    } else {
      const msg = result.msg
      message.error(msg)
    }
  }
}

/**
 * 退出登录同步action
 * @returns
 */
export const logout = () => {
  storageUtils.removeUser()
  return { type: RESET_USER }
}
